var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 6.875C8.33027 6.875 8.75 6.45527 8.75 5.9375C8.75 5.41973 8.33027 5 7.8125 5C7.29473 5 6.875 5.41973 6.875 5.9375C6.875 6.45527 7.29473 6.875 7.8125 6.875ZM7.8125 10.9375C8.33027 10.9375 8.75 10.5177 8.75 10C8.75 9.48225 8.33027 9.0625 7.8125 9.0625C7.29473 9.0625 6.875 9.48225 6.875 10C6.875 10.5177 7.29473 10.9375 7.8125 10.9375ZM8.75 14.0625C8.75 14.5802 8.33027 15 7.8125 15C7.29473 15 6.875 14.5802 6.875 14.0625C6.875 13.5448 7.29473 13.125 7.8125 13.125C8.33027 13.125 8.75 13.5448 8.75 14.0625ZM12.1875 6.875C12.7052 6.875 13.125 6.45527 13.125 5.9375C13.125 5.41973 12.7052 5 12.1875 5C11.6698 5 11.25 5.41973 11.25 5.9375C11.25 6.45527 11.6698 6.875 12.1875 6.875ZM13.125 10C13.125 10.5177 12.7052 10.9375 12.1875 10.9375C11.6698 10.9375 11.25 10.5177 11.25 10C11.25 9.48225 11.6698 9.0625 12.1875 9.0625C12.7052 9.0625 13.125 9.48225 13.125 10ZM12.1875 15C12.7052 15 13.125 14.5802 13.125 14.0625C13.125 13.5448 12.7052 13.125 12.1875 13.125C11.6698 13.125 11.25 13.5448 11.25 14.0625C11.25 14.5802 11.6698 15 12.1875 15Z",
    fill: "#626268"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.a0441ed32a7cb6f8ec4cd303669a2be8.svg";
export { ForwardRef as ReactComponent };